// Taken from lodash: https://github.com/lodash/lodash/blob/master/uniqueId.js

const getState = (state, newState) => ({ ...state, ...newState });

export default getState;
